module.exports = __webpack_public_path__ + "img/icon_waitDeal@3x.a6a08743.png";